import _import from './_import.js';

export default [
    // // s1
    // {
    //     path: 'simbox/poster',
    //     component: _import('simbox/poster')
    // },

    // simbox 动态路由
    {
        path: 'simbox/:type',
        component: _import('simbox/common_simbox')
    }
];


// WEBPACK FOOTER //
// ./src/router/simbox.js